import { ApiService } from "./api.service";
export default class PaymentMethodsService extends ApiService {
  namespace = "paymentMethod";
  icon = "CreditCards";
  name = "method";
  favicon = "CreditCardGreen";
  window = 290;
  Width = 690;
  DOMAIN = -55;
  singular = this.terminology.method.singular;
  plural = this.terminology.method.plural;
  vowel = this.terminology.method.vowel;
  action = "action";
  singular = this.terminology.method.singular;
  plural = this.terminology.method.plural;
  vowel = this.terminology.method.vowel;
  constructor() {
    super("acct-payment-methods");
  }
}
